import React from 'react';
import dayjs from 'dayjs';
import { IconButton } from '@material-ui/core';
import "./booking-details.css";

const TimeBlockDetails = ({
  booking,
  deleteTimeBlock,
  updateTimeBlock,
  close,
  selectedDate
}) => {
  const handleOverLayClick = e => {
    if (e.target.className === "booking__details--overlay") {
      close();
    }
  };

  return (
    <div
      className="booking__details--overlay"
      onClick={handleOverLayClick}
      onKeyPress={handleOverLayClick}
      role="button"
      tabIndex="0"
    >
      <div className="booking__details--modals">
        <div className="booking__details_view">
          <div className="booking_details_container">
            <div
              className="booking__details--header"
              style={{ paddingTop: 0 }}
            >
              <span
                onClick={() => deleteTimeBlock(booking)}
                onKeyPress={() => deleteTimeBlock(booking)}
                role="button"
                tabIndex="0"
              >
                <IconButton>
                  <i className="fa fa-trash-o" />
                </IconButton>
              </span>
              <span
                onClick={() => updateTimeBlock(booking)}
                onKeyPress={() => updateTimeBlock(booking)}
                role="button"
                tabIndex="0"
              >
                <IconButton>
                  <i className="fa fa-edit" />
                </IconButton>
              </span>
              <span
                onClick={close}
                onKeyPress={close}
                role="button"
                tabIndex="0"
              >
                <IconButton>
                  <svg
                    className="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </IconButton>
              </span>
            </div>
        
            <div className="booking__details--content">
              <div className="booking__details__name">
                TIME BLOCK
              </div>
              <div className="booking__details__date">
                {booking.scheduled_pickup_time} to {booking.scheduled_dropoff_time}
              </div>
              <div className="booking__details__date">
                {dayjs(selectedDate).format("dddd, LL")}
              </div>
              <div className="booking__details__date">
                {booking.admin_note}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TimeBlockDetails;